<template>
	<AppLayout :show-footer="false">
		<main class="not-found-view view">
			<section class="page-not-found" id="page-not-found">
				<div class="page-not-found__container container">
					<div class="page-not-found__body text-center">
						<div class="page-not-found__404">
							<h1 class="sr-only">{{ $t('landing.not_found_view.title') }}</h1>
							<img src="@/assets/landing/images/404.svg" alt="404" />
						</div>

						<div class="page-not-found__description">
							{{ $t('landing.not_found_view.description') }}
						</div>

						<div class="page-not-found__btn-wrapper">
							<a href="/" class="page-not-found__btn btn btn--default">
								{{ $t('landing.not_found_view.btn_text') }}
							</a>
						</div>
					</div>
				</div>

				<div class="page-not-found__right-image" aria-hidden="true">
					<img src="@/assets/landing/images/skull.png" alt="" />
				</div>

				<div class="page-not-found__left-image" aria-hidden="true">
					<img src="@/assets/landing/images/gradient-heart.png" alt="" />
				</div>
			</section>
		</main>
	</AppLayout>
</template>

<script>
import AppLayout from '@/components/landing/AppLayout.vue'

export default {
	name: 'NotFoundView',
	components: { AppLayout },
	mounted() {
		window.addEventListener('popstate', function () {
			location.reload()
		})
	}
}
</script>
